import { ActionTypes } from './constants';

export const clearFacetOptions = facetId => ({
    type: ActionTypes.CLEAR_FACET_OPTIONS,
    payload: { facetId },
});

export const clearManyFacetOptions = facetIds => ({
    type: ActionTypes.CLEAR_MANY_FACET_OPTIONS,
    payload: { facetIds },
});

export const selectFacetOption = (facetId, optionId) => ({
    type: ActionTypes.SELECT_FACET_OPTION,
    payload: {
        facetId,
        optionId,
    },
});

export const checkFacetOption = (facetId, optionId) => ({
    type: ActionTypes.CHECK_FACET_OPTION,
    payload: {
        facetId,
        optionId,
    },
});

export const uncheckFacetOption = (facetId, optionId) => ({
    type: ActionTypes.UNCHECK_FACET_OPTION,
    payload: {
        facetId,
        optionId,
    },
});
